import { initAnimationObserver } from '../_shared/animationObserver';

const blocks = document.querySelectorAll('.k8-heading-and-text');

blocks.forEach(block => {
    if (block.dataset.animationEnabled) {
        const inner = block.querySelector('.k8-heading-and-text__inner');
        const innerBlocks = Array.from(inner.children);
        const staggerDelay = parseInt(block.dataset.staggerDelay) || 150;
        const animationType = block.dataset.animationType || 'fadeIn';
        
        const rawMargin = parseInt(block.dataset.rootMargin) || -100;
        const rootMargin = Math.max(rawMargin, -(Math.floor(window.innerHeight * 0.1)));        

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    innerBlocks.forEach((el, i) => {
                        if (animationType === 'fadeInStagger') {
                            el.style.setProperty('--animate-delay', `${i * staggerDelay}ms`);
                            el.classList.add('animate__animated', 'animate__fadeIn', 'animate__delay-custom');
                        } else {
                            el.classList.add('animate__animated', `animate__${animationType}`);
                        }
                    });
                    observer.unobserve(entry.target);
                }
            });
        }, { rootMargin: `${rootMargin}px`, threshold: 0.1 });

        observer.observe(inner);

    }
});

